export class LoginRequest {
  constructor( 
    public loginName: string,
    public password: string ){}
}